import { render, staticRenderFns } from "./modalRedCard.vue?vue&type=template&id=f1fa770c&"
import script from "./modalRedCard.vue?vue&type=script&lang=js&"
export * from "./modalRedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports